import {Grid, makeStyles} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {CardFieldProps, CardFieldV2} from 'Shared/components/CardFieldV2';
import React from 'react';

type GridHeaderProps = {
  data: Record<string, string | Date | number>;
  labelMapping: Record<string, string>;
};

const useGridHeaderStyles = makeStyles(() => ({
  headerGridContainer: {
    justifyContent: 'space-between',
    textAlign: 'left',
    padding: '2rem',
  },
  cardFieldName: {
    fontSize: '1rem',
    lineHeight: '1.2rem',
  },
  cardFieldValue: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.2rem',
  },

  gridItem: {
    minWidth: 'max-content',
  },
}));

export const GridHeaderLoader = () => <Skeleton height={50} />;

export const GridHeader = React.memo((props: GridHeaderProps) => {
  const {data, labelMapping} = props;
  const classes = useGridHeaderStyles();

  const headerItems = Object.entries(data).map<CardFieldProps>(([key, value]) => ({
    name: labelMapping[key] ?? key,
    value: value,
  }));

  return (
    <Grid container spacing={2} className={classes.headerGridContainer}>
      {headerItems.map(item => (
        <Grid item key={item.name} xs={12} sm={6} md={1} className={classes.gridItem}>
          <CardFieldV2
            name={item.name}
            value={item.value}
            styles={{name: classes.cardFieldName, value: classes.cardFieldValue}}
          />
        </Grid>
      ))}
    </Grid>
  );
});
